import Uuid from '../../../model/Uuid';

// eslint-disable-next-line prefer-regex-literals
const uuidRegex = new RegExp('^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-f]{12}$', 'i');

export default (items: string): Uuid[] => {
  if (items === undefined || items === null) {
    return null;
  }

  if (!items) {
    return [];
  }

  return items.split(',')
    .filter(item => !!item && item.match(uuidRegex))
    .map(item => item);
};
